export default "__VITE_ASSET__03d9c05c__"